<div>
  <div class="dialog-heading">
    <h5>{{ data.title }}</h5>
    <span style="flex: 1 1 auto"></span>
    <mat-icon class="close-dialog" aria-hidden="false" mat-dialog-close aria-label="Close icon">close</mat-icon>
  </div>
  
  <mat-dialog-content>
    <p class="mat-body" [innerHTML]="data.message"></p>
      <p style="width:25%">
          <input
              matInput
              (change)="setQuoteDueDate()"
              type="date"
              id="quoteDueDate"
              [(ngModel)]="quoteDueDate"
              style="border: 0px; height: 100%"
              matTooltipClass="enable-line-break ud-tooltip"
          />
      </p>
  </mat-dialog-content>

  <!-- This are the actions of the dialog, containing the primary and the cancel button-->
  <mat-dialog-actions class="actions">
    <button mat-stroked-button color="accent" id="confirmPrimaryBtn" mat-dialog-close [mat-dialog-close]="true">{{ data.primaryButtonText }}</button>
    <button mat-raised-button color="accent" mat-dialog-close [mat-dialog-close]="false" [disabled]="!quoteDueDate">{{ data.secondaryButtonText }}</button>
  </mat-dialog-actions>
</div>